import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import './MainRegister.scss';

export default class MainRegister extends Component {
  state = {
    btnAboActive: false,
    btnColActive: false,
    btnContinuar: false,
    estiloUno: 'squer_test squet-img-colab',
    estiloDos: 'squer_test squet-img',
    estiloA: 'btnRegistroA_a btnDesactiveA',
    estiloB: 'btnRegistroA_a btnDesactiveB',
  };

  cambioUno = () => {
    this.setState(
      (prevState, props) => ({
        btnAboActive: !prevState.btnAboActive,
      }),
      () => {
        if (this.state.btnAboActive) {
          this.props.getAccountType(this.state.btnAboActive, 'lawyer');
        } else {
          this.props.getAccountType(false, '');
        }
      }
    );

    this.state.btnAboActive
      ? this.setState({ estiloDos: 'squer_test squet-img' })
      : this.setState({ estiloDos: 'squer_test squet-img_active' });

    this.state.btnAboActive
      ? this.setState({ estiloA: 'btnRegistroA_a btnDesactiveA' })
      : this.setState({ estiloA: 'btnRegistroA_a btnActiveA' });

    if (this.state.btnColActive) {
      this.setState({
        btnColActive: false,
      });
      this.setState({ estiloB: 'btnRegistroB_a btnDesactiveB' });
    }
  };

  cambioDos = () => {
    this.setState(
      (prevState, props) => ({
        btnColActive: !prevState.btnColActive,
      }),
      () => {
        if (this.state.btnColActive) {
          this.props.getAccountType(this.state.btnColActive, 'lawfirm');
        } else {
          this.props.getAccountType(false, '');
        }
      }
    );

    this.state.btnColActive
      ? this.setState({ estiloUno: 'squer_test squet-img-colab' })
      : this.setState({ estiloUno: 'squer_test squet-img-colab_active' });

    this.state.btnColActive
      ? this.setState({ estiloB: 'btnRegistroB_a btnDesactiveB' })
      : this.setState({ estiloB: 'btnRegistroB_a btnActiveB' });

    if (this.state.btnAboActive) {
      this.setState({
        btnAboActive: false,
      });
      this.setState({ estiloA: 'btnRegistroA_a btnDesactiveA' });
    }
  };

  render() {
    return (
      <>
        <Grid container>
          <Grid item xs={12}>
            <p className="text-Regsito">Deseas registrarte como:</p>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={6}>
            {/*  <div
              className={this.state.estiloDos}
              onClick={this.cambioUno}
            ></div> */}
            <div className="btnContainerA">
              <div className="btnRegistroA ">
                <div className={this.state.estiloA} onClick={this.cambioUno}>
                  <figure className="btnRegistroA_fig"></figure>
                  <p className="btnRegistroA_p">Abogado</p>
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={6}>
            {/*            <div
              className={this.state.estiloUno}
              onClick={this.cambioDos}
            ></div> */}

            <div className="btnContainerB">
              <div className="btnRegistroB">
                <div className={this.state.estiloB} onClick={this.cambioDos}>
                  <figure className="btnRegistroB_fig"></figure>
                  <p className="btnRegistroB_p">Despacho</p>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </>
    );
  }
}
